<template>
    <div>
        <button @click.prevent="toggle" class="pill pill--column">
            <span class="pill__label w-full"><span v-if="value">{{ options[value] }}</span></span>
            <icon type="chevron-bottom" color="gray" />
        </button>
        <ul v-if="open" class="dropdown-menu" role="menu" :aria-expanded="open">
            <li v-for="(option, value) in options" :key="value" class="dropdown-menu__item">
                <a href="#" @click.prevent="update(value)" class="dropdown-menu__link">
                    {{ option }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
/* global EventBus */
import Icon from './Icon'

export default {
    props: {
        options: {
            required: true
        },

        value: {
            required: false,
            default: null
        }
    },

    data () {
        return {
            open: false,
            extended: false
        }
    },

    created () {
        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.close()
            }
        })
    },

    methods: {
        toggle () {
            this.open = !this.open
        },

        close () {
            this.open = false
        },

        toggleExtension () {
            this.extended = !this.extended
        },

        update (value) {
            this.$emit('input', value)
            this.close()
        }
    },

    components: {
        Icon
    }
}
</script>
